// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/AssetPage/styles.scss
// module id = 1096
// module chunks = 0